'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _ApiClient = require('../lib/ApiClient');

var _ApiClient2 = _interopRequireDefault(_ApiClient);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Class for the Token API
 */
var Token = function () {
  /**
   * Creates a new Token API Client
   * @param {string} host
   * @param {string} environment
   * @param {string} apiKey
   */
  function Token(host, environment, apiKey) {
    (0, _classCallCheck3.default)(this, Token);

    // isTokenClient tells it not to initialise another API client, else infinite loop
    this.apiClient = new _ApiClient2.default(host, 'token/v1', environment, {
      apiKey: apiKey,
      isTokenClient: true
    });
  }

  /**
   * Creates a token and returns the token
   * @param {string} webAppName - 'cove-bot' or 'webview'
   * @param {*} custom
   * @returns {string}
   */


  (0, _createClass3.default)(Token, [{
    key: 'create',
    value: function create(webAppName, custom) {
      return this.apiClient.fetch('POST', 'create', null, { webAppName: webAppName, custom: custom }).then(function (data) {
        return data.token;
      });
    }

    /**
     * Validates a token and returns the payload
     * @param {string} token - 'cove-bot' or 'webview'
     * @returns {*}
     */

  }, {
    key: 'validate',
    value: function validate(jwt) {
      return this.apiClient.fetch('POST', 'validate', null, { jwt: jwt }).then(function (data) {
        return data.payload;
      });
    }

    /**
     * Searches
     * @param {string} token - 'cove-bot' or 'webview'
     * @returns {*}
     */

  }, {
    key: 'loginTokens',
    value: function loginTokens(login_uuid) {
      return this.apiClient.fetch('GET', 'loginTokens', { login_uuid: login_uuid }, null).then(function (data) {
        return data;
      });
    }

    /**
     * Refreshes a token and returns the new token
     * @param {string} jwt - The token to refresh
     * @param {{ ?facebook_id: string, ?web_id: string }} credentials - FBID/PSID of the user
     * @returns {string}
     */

  }, {
    key: 'refresh',
    value: function refresh(jwt, credentials) {
      var facebook_id = credentials.facebook_id,
          web_id = credentials.web_id;

      return this.apiClient.fetch('POST', 'refresh', null, { jwt: jwt, facebook_id: facebook_id, web_id: web_id }).then(function (data) {
        return data.token;
      });
    }
  }]);
  return Token;
}();

exports.default = Token;